import { IPromise, IScope } from 'angular'
import { $q } from '../../../../ng-compat/imports'
import { STEPS } from './Steps/types'

interface ServiceModalOptions {
  startWithStep: STEPS
  isEditing: boolean
}

/**
 * Controller class for service order customer modal
 *
 * @class ServiceModalController
 */
export class ServiceModalController {
  public readonly close: () => void
  public startWithStep: STEPS
  public isEditing: boolean
  private readonly internalClose: (val: IPromise<any>) => void

  constructor(
    $scope: IScope,
    close: (val: IPromise<any>) => void,
    public readonly options: ServiceModalOptions,
    private readonly vdEscapeStack: any
  ) {
    'ngInject'
    this.internalClose = close
    this.close = () => this.internalClose($q.reject())

    this.startWithStep = options.startWithStep
    this.isEditing = options.isEditing

    // Handle escape key
    this.vdEscapeStack.register(this.close)
    $scope.$on('$destroy', () => this.vdEscapeStack.deregister(this.close))
  }
}
